<div class="pt-4" *ngIf="serverError !== null">
  <div class="alert alert-danger">
    Server Error: {{ serverError }}
  </div>
</div>

<div class="pt-4 pl-md-4 mb-6" *ngIf="serverError === null">

  <div class="alert alert-info">
    This list only includes event types with event type-wide waitlists. Waitlists for specific events are listed under Individual Event Waitlists.
  </div>

  <select class="custom-select w-auto"
          name="status"
          [(ngModel)]="status"
          (ngModelChange)="loadEventTypes()">
    <option [ngValue]="EventTypeStatus.active">Active Event Types</option>
    <option [ngValue]="EventTypeStatus.draft">Draft Event Types</option>
    <option [ngValue]="EventTypeStatus.retired">Retired Event Types</option>
  </select>

  <div class="rounded-table-wrapper table-responsive-lg mt-2">
    <table class="table table-hover"
           *ngIf="!loadingEventTypes && (eventTypes.length > 0)">
      <thead>
        <tr>
          <th>Event Type</th>
          <th># Active Waitlist Entries</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let eventType of eventTypes"
            routerLink="/events/scheduled/waitlists/event-type/{{ eventType.id }}"
            class="cursor-pointer">
          <td>{{ eventType.name}}</td>
          <td *ngIf="loadingWaitlistCounts" class="text-muted">Loading...</td>
          <td *ngIf="!loadingWaitlistCounts">{{ waitlistCounts[eventType.id] }}</td>
        </tr>
      </tbody>
    </table>
    <table class="table"
           *ngIf="loadingEventTypes || (eventTypes.length === 0)">
      <tbody>
        <tr>
          <td colspan="99">
            {{ loadingEventTypes ? 'Loading...' : 'No event types with event type-wide waitlists.' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
